// Must stay first: patches ES2022 methods that shipped libraries call at import
// time on browsers below Chrome 93 / Safari 15.4 (CM2-2HR/2HQ/2HN/2HS).
import "./es2022-shims";

import { createRoot } from "react-dom/client";
import App from "./App";
import { installTranslationGuard } from "./dom-translation-guard";

// Must run before the first render: page translators re-parent React-owned text
// nodes and the resulting removeChild/insertBefore throw kills the whole commit.
installTranslationGuard();


const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  //<React.StrictMode>
  <App />
  //</React.StrictMode>
);
